
import { defineComponent } from 'vue'

interface SeverityT {
  title: string
  icon: string
  iconColor: string
  value: number
}

/**
 * Component to show total severity levels
 */
export default defineComponent({
  name: 'SeverityCounts',
  props: {
    high: {
      type: Number,
      default: 0
    },
    medium: {
      type: Number,
      default: 0
    },
    low: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    severityList(): Array<SeverityT> {
      return [
        {
          title: 'critical',
          icon: 'issue-critical',
          iconColor: 'cherry',
          value: this.high
        },
        {
          title: 'major',
          icon: 'issue-major',
          iconColor: 'honey',
          value: this.medium
        },
        {
          title: 'minor',
          icon: 'issue-minor',
          iconColor: 'vanilla-400',
          value: this.low
        }
      ]
    }
  }
})
